<div class="d-flex profile-media align-items-center" (click)="isShow =!isShow">
  @if (this.userType != 'super-admin') {
  @if(portalProfile != ''){
  <img class="img-30"
    [src]="portalProfile && portalProfile !== '' ? portalProfile : 'assets/images/dashboard/profile.png'"
    alt="User Profile" style="height: 30px; border-radius: 50%;" />
  } @else {
  <img class="img-30" src="assets/images/dashboard/profile.png" alt="">
  }
  } @else {
  <img class="img-30" src="assets/images/dashboard/profile.png" alt="">
  }
  @if(userType == 'super-admin'){
  <div class="flex-grow-1"><span>{{user}}</span>
  </div>
  } @else {
  <div class="flex-grow-1"><span>{{user}}</span>
    <p class="mb-0 font-outfit">
      <ng-container *ngIf="isFirstLogin; else showRole">COMPANY</ng-container>
      <ng-template #showRole>{{ role }}</ng-template>
    </p>
  </div>
  }
  <ul class="profile-dropdown onhover-show-div" [class.active]="isShow">
    @if(userType == 'super-admin'){
    <li (click)="editSuperadmin()">
      <app-feather-icons [icons]="'user'"></app-feather-icons>
      <span>ACCOUNT</span>
    </li>
    }@else {
    <li (click)="openUserProfile()">
      <app-feather-icons [icons]="'user'"></app-feather-icons>
      <span>ACCOUNT</span>
    </li>
    }
    @if(userType == 'super-admin'){
    <li>
      <a [routerLink]="['/superadmin/change-password']"> <app-feather-icons [icons]="'lock'"></app-feather-icons>
        <span>Change Password</span>
      </a>
    </li>
    } @else {
    <li>
      <a [routerLink]="['/change-password']"> <app-feather-icons [icons]="'lock'"></app-feather-icons>
        <span>Change Password</span>
      </a>
    </li>
   
    @if((tokenInfo?.companyData?.isFreeTrial === true) && (isFirstLogin === true)) {
    <li (click)="openModal()">
      <app-feather-icons [icons]="'x-circle'"></app-feather-icons>
      <span>CANCEL TRIAL PLAN</span>
    </li>
    }

    }

    <!-- <li>
      <a [routerLink]="['/tasks']"> <app-feather-icons [icons]="'file-text'"></app-feather-icons>
        <span>Taskboard</span></a>
    </li>
    <li>
      <a [routerLink]="['/user/edit-profile']">
        <app-feather-icons [icons]="'settings'"></app-feather-icons> <span>Settings</span>
      </a>
    </li> -->
    <li (click)="logOut()">
      <app-feather-icons [icons]="'log-in'"></app-feather-icons><span>LOG OUT</span>
    </li>
  </ul>
</div>

<ng-template #cancelSubscriptionModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title text-danger">Cancel Trial Plan</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body">
    <p>Are you sure you want to <strong>cancel your 7 days trial plan</strong>? This action cannot be undone.</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel')">No, Keep
      Subscription</button>
    <button type="button" class="btn btn-danger" (click)="confirmCancelSubscription(modal)">Yes, Cancel</button>
  </div>
</ng-template>

<app-loader [loading]="isLoading"></app-loader>